interface PersonaCardProps {
  className?: string;
  /** Persona image URL */
  image: string;
  /** Persona title, e.g. "Менеджеры и руководители" */
  title: string;
  /** Persona description */
  description: string;
}

/** Persona card (405×370) for «Для кого» section */
export function PersonaCard({ className = "", image, title, description }: PersonaCardProps) {
  return (
    <div
      className={`bg-white relative flex flex-col gap-[16px] h-[370px] items-start p-[20px] rounded-[16px] w-full hover:shadow-[0px_0px_20px_rgba(0,0,0,0.07)] transition-shadow ${className}`}
    >
      {/* Illustration */}
      <div className="absolute left-1/2 -translate-x-1/2 top-[167px] h-[203px] w-[244px] overflow-hidden pointer-events-none">
        <img
          src={image}
          alt={title}
          className="absolute inset-0 size-full object-cover"
        />
      </div>

      {/* Title */}
      <h3
        className="[font-family:var(--font-commissioner)] font-bold not-italic text-[24px] leading-[28px] text-[rgba(0,0,0,0.9)] tracking-[-0.48px] relative w-full"
        style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
      >
        {title}
      </h3>

      {/* Description */}
      <p
        className="[font-family:var(--font-commissioner)] font-medium not-italic text-[16px] leading-[24px] text-[rgba(0,0,0,0.8)] relative w-full"
        style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
      >
        {description}
      </p>
    </div>
  );
}
